import { object, string, number } from 'yup';

export const noQuantityValidationSchema = object().shape({
  sku: string().required(),
  description: string().required(),
});

export default object().shape({
  sku: string().required(),
  description: string().required(),
  quantity: number().required().notOneOf([0]),
});
